// Keep the custom cart count aligned with Horizon's native cart updates.
import { StandardEvents } from '@shopify/events';
let cartRequest;
async function updateCartCount() {
  cartRequest?.abort();
  cartRequest = new AbortController();
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, { signal: cartRequest.signal, credentials: 'same-origin' });
    if (!response.ok) return;
    const cart = await response.json();
    document.querySelectorAll('[data-kb-cart-count]').forEach((count) => {
      count.textContent = String(cart.item_count);
      count.closest('a,button')?.setAttribute('aria-label', `Cart, ${cart.item_count} items`);
    });
  } catch (error) {
    if (error.name !== 'AbortError') console.debug('Cart count will refresh on the next navigation.');
  }
}
document.addEventListener(StandardEvents.cartLinesUpdate, async (event) => {
  try { if (event.promise) await event.promise; } catch { return; }
  await updateCartCount();
});
window.addEventListener('pageshow', updateCartCount);
document.addEventListener('click', (event) => {
  if (event.target.closest('.kb-mobile-menu a')) {
    event.target.closest('.kb-mobile')?.removeAttribute('open');
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.kb-mobile[open]');
  if (menu) { menu.removeAttribute('open'); menu.querySelector('summary')?.focus(); }
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-kb-plan-select]');
  if (!select) return;
  const card = select.closest('[data-kb-subscription-card]');
  const option = select.selectedOptions[0];
  card.querySelector('[data-kb-plan-price]').textContent = option.dataset.price;
  card.querySelector('[data-kb-plan-savings]').textContent = option.dataset.savings;
});

document.addEventListener(StandardEvents.cartError, (event) => {
  if (event.code !== 'SERVICE_UNAVAILABLE') return;
  const form = event.target.closest('#replacement-scratchers product-form-component');
  if (!form) return;
  form.querySelector('[ref="liveRegion"]').textContent = 'Could not add your 12-pack. Check your connection and try again.';
});
